export default __webpack_public_path__ + "static/media/dataSync.c23a1c56.gif";